const getAppAccess = (user, appId) =>
  (user.access ?? []).find((access) => access.app === appId && !access.archived);

// teams puede traer ids nulos; se descartan igual que en bq-gh-api-gateway.
const getAppTeamIds = (user, appId) =>
  (getAppAccess(user, appId)?.teams ?? []).filter(Boolean);

// Un administrador sin equipos guardados en la app administra "Todos los equipos".
export const hasAssignedTeams = (user, appId) => getAppTeamIds(user, appId).length > 0;

// La búsqueda por app_access también regresa accesos archivados; esos no se ofrecen.
// Con la notificación por equipo, un administrador de "Todos los equipos" recibiría todo igual.
export const selectableApprovers = (users, appId, byTeam) =>
  (users ?? []).filter((user) =>
    byTeam ? hasAssignedTeams(user, appId) : Boolean(getAppAccess(user, appId))
  );

export const buildApproverOption =(user, appId, teamNamesById = {}) => {
  const teamNames = getAppTeamIds(user, appId)
    .map((teamId) => teamNamesById[teamId])
    .filter(Boolean);
  const scope = hasAssignedTeams(user, appId)
    ? teamNames.length ? teamNames.join(", ") : "Equipos asignados"
    : "Todos los equipos";
  const name = user.fullName ? `${user.fullName} (${user.email})` : user.email;
  return {
    value: user._id,
    label: `${name} — ${scope}`,
    user,
  };
};
